import { render, staticRenderFns } from "./CertificadoBeneficios.vue?vue&type=template&id=19002baa&scoped=true"
import script from "./CertificadoBeneficios.vue?vue&type=script&lang=ts"
export * from "./CertificadoBeneficios.vue?vue&type=script&lang=ts"
import style0 from "./CertificadoBeneficios.vue?vue&type=style&index=0&id=19002baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19002baa",
  null
  
)

export default component.exports